/** i18n 命名空间(locales/{zh-CN,en}/partner-portal.json);与平台端 platform-partners 分开。 */
export const PARTNER_PORTAL_NS = "partner-portal";

/** react-query key 根:渠道后台所有查询挂在这下面,写操作后一把刷新。 */
export const PARTNER_PORTAL_KEY = ["partner-portal"] as const;
